import React from 'react';
import * as messages from '@radnuc/messages';
//import {HealthData} from '../Health';
import './HealthStatusDisplay.css'

export class HealthData {
    component: number;
    state: number; status: string; lastMessage: Date;
    inSummary: boolean; diskUsedPct: string|undefined; diskStatus: string|undefined;
    inSubSystemSummary: boolean;
    heartbeat: number;
    constructor(component: number){
        this.component = component;
        this.state = -1;
        this.status = "NOTUSED";
        this.lastMessage = new Date(0);
        this.inSummary = false;
        this.heartbeat = 10000;
        this.inSubSystemSummary = true;
    }
}

interface HealthStatusDisplayInterface {open: ()=> void, close: ()=> void}
//export interface HealthSummaryDisplayProps {healthData: HealthData[], isPrimary?: boolean}
export interface HealthSummaryDisplayProps {healthData: Map<number,HealthData>, isPrimary?: boolean}
export interface HealthSummaryDisplayState {menuOpen: boolean, time: Date}
export class HealthStatusSummaryDisplay extends React.Component<HealthSummaryDisplayProps,HealthSummaryDisplayState> {
    heartbeatInterval:number = 10000*1.5; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    constructor(props: HealthSummaryDisplayProps) {
        super(props)
        this.handleHealthSummaryButtonClick = this.handleHealthSummaryButtonClick.bind(this);
        this.state = {
            menuOpen: false,
            time: new Date()
        }
    }

    handleHealthSummaryButtonClick(flag: boolean){
        this.setState(() => ({
            menuOpen: flag
        }));
    }

    getSummaryHealthState(){
        let componentHealthState = Array();
        this.props.healthData.forEach((componentData)=>{
            if(componentData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                if(componentData.inSummary){
                    componentHealthState.push(componentData.state);
                } else {
                    componentHealthState.push(-1); //Don't count for summary status
                }
            } else {
                if(componentData.inSummary){
                    //Timed out
                    componentHealthState.push(4); //Offline
                } else {
                    componentHealthState.push(-1); //Don't count for summary status
                }
            }
        });

        let summaryHealthState = 0;
        if(componentHealthState.includes(1)){
            //Set to OK, class good
            summaryHealthState = messages.Rad.HealthState.GOOD;
        }
        if(componentHealthState.includes(2)){
            //Set to ATTN, class degraded
            summaryHealthState = messages.Rad.HealthState.DEGRADED;
        }
        if(componentHealthState.includes(3)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        if(componentHealthState.includes(4)){
            //Set to FAIL, class bad
            summaryHealthState = messages.Rad.HealthState.BAD;
        }
        const isOffline = (currentValue:number) => (currentValue===-1 || currentValue===4);
        if(componentHealthState.every(isOffline)){
            //Set to OFFLINE, class bad
            summaryHealthState = 4;
        }
        if(componentHealthState.includes(0)){
            //Set to WAIT, class good
            summaryHealthState = 0;
        }
        return (summaryHealthState)

    }

    getSummaryString(summaryHealthState: number){
        if(summaryHealthState === messages.Rad.HealthState.GOOD){
            return 'OK';
        } else if (summaryHealthState === messages.Rad.HealthState.DEGRADED){
            return 'ATTN';
        } else if (summaryHealthState === messages.Rad.HealthState.BAD){
            return 'FAIL';
        } else if (summaryHealthState === 4) {
            return 'OFFLINE';
        } else if (summaryHealthState === 0) {
            return 'WAIT';
        } else {
            return 'WAIT';
        }
    }

    getSummaryClass(summaryHealthState: number){
        if(summaryHealthState === messages.Rad.HealthState.GOOD){
            return 'good';
        } else if (summaryHealthState === messages.Rad.HealthState.DEGRADED){
            return 'degraded';
        } else if (summaryHealthState === messages.Rad.HealthState.BAD){
            return 'bad';
        } else if (summaryHealthState === 4) {
            return 'fail';
        } else if (summaryHealthState === 0) {
            return 'good';
        } else {
            return '';
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const healthStatusDisplayInterface = {
            open: ()=>this.setState({menuOpen: true}),
            close: ()=>this.setState({menuOpen: false})
        }
        const summaryHealthState = this.getSummaryHealthState();
        const healthStateSummaryString = this.getSummaryString(summaryHealthState);
        const healthStateClass = this.getSummaryClass(summaryHealthState);
        return (
            <>
            <div id="system-status" className={"metric-container "+healthStateClass} style={{cursor:'pointer'}} onClick={()=>{this.handleHealthSummaryButtonClick(true)}}>
                <label id="system-status" className={"metric-title good " +healthStateClass}>System Status</label>
                <label id="system-status" className={"metric "+healthStateClass}>{healthStateSummaryString}</label>
            </div>
            <HealthStatusDisplay menuOpen={this.state.menuOpen} healthData={this.props.healthData} healthStatusDisplayInterface={healthStatusDisplayInterface} isPrimary={this.props.isPrimary}/>
            </>
        )
    }
}

export interface HealthComponentDisplayProps {title: string, healthData: HealthData | undefined}
export interface HealthComponentDisplayState {expanded: boolean, offline: boolean, time: Date}
export class HealthComponentDisplay extends React.Component<HealthComponentDisplayProps,HealthComponentDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;
    heartbeatInterval:number = 10000*1.2; //msec
    ui_message: string = "Connecting...";
    disk_status_message: string | undefined = "N/A";
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: HealthComponentDisplayProps) {
        super(props)

        this.state ={
            expanded: false,
            offline: false,
            time: new Date()
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
    }

    componentDidMount(){
        this.init();
    }

    handleAccordionClick(){
        if(this.accordion_element.current !== null){
            this.accordion_element.current.classList.toggle("active");
        }
        if(this.panel_element.current !== null){
            var panel = this.panel_element.current;
            panel.classList.toggle("active");
            if(panel !== null){
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }
    }

    init(){
        this.ui_message = 'Connecting...';
        this.disk_status_message = 'N/A';
    }

    healthStateToClass(healthState:number){
        switch(healthState){
            case messages.Rad.HealthState.GOOD:
                return 'good'
            case messages.Rad.HealthState.DEGRADED:
                return 'degraded'
            case messages.Rad.HealthState.BAD:
                return 'bad'
            case 4:
                return 'offline'
            default:
                return ''
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        let healthStatusClass;
        let disk_status_message;
        let statusString;
        if(thisHealthData === undefined){
            this.ui_message = "OFFLINE";
            healthStatusClass =  "offline";
            disk_status_message = 'N/A';
            statusString = this.ui_message;
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                this.ui_message = thisHealthData.status;
                healthStatusClass =  this.healthStateToClass(thisHealthData.state);
                if(thisHealthData.component === messages.Rad.HealthComponent.LOG){
                    disk_status_message = thisHealthData.diskStatus;
                }
            } else {
                this.ui_message = "OFFLINE";
                healthStatusClass =  "offline";
                disk_status_message = 'N/A';
            }
            statusString = this.ui_message;
            if(!thisHealthData.inSummary){
                statusString = "("+statusString+")";
            }

            var statusMetricContainerHeight:string;
            if(this.state.expanded){
                statusMetricContainerHeight= "100%";
            } else {
                statusMetricContainerHeight= "1.2em";
            }

            //Only show for Log health component
            var logStatus;
            if(thisHealthData.component === messages.Rad.HealthComponent.LOG){
                    logStatus =
                        <div className="status-metric-container">
                            <label className="status-metric-title">Disk Used</label>
                            <label className={"status-metric "+ healthStatusClass}>{disk_status_message}</label>
                        </div>
            }
        }

        return (
            <>
            <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
        		<div className="status-metric-container">
                    <label className="status-metric-title-big">{this.props.title}</label>
                    <label className="status-metric-big">
                        <div className={"status-metric-indicator "+healthStatusClass}></div>
                    </label>
        		</div>
        	</button>
            <div className="panel" ref={this.panel_element}>
                <div className="status-metric-container">
                    <label className="status-metric-title">Status</label>
                    <label className={"status-metric "+ healthStatusClass}>{statusString}</label>
                </div>
                {logStatus}
            </div>
            </>
        )
    }
}

export interface HealthStatusDisplayProps {menuOpen: boolean, healthData: Map<number,HealthData>, healthStatusDisplayInterface:HealthStatusDisplayInterface, isPrimary?: boolean}
export class HealthStatusDisplay extends React.Component<HealthStatusDisplayProps> {
    constructor(props: HealthStatusDisplayProps) {
        super(props)
        this.handleHealthCloseButtonClick = this.handleHealthCloseButtonClick.bind(this);
    }

    handleHealthCloseButtonClick(){
        this.props.healthStatusDisplayInterface.close();
    }

    render() {
        var sidenavClassName = "sidenav";
        if(this.props.menuOpen){
            sidenavClassName += " open"
        }
        let primaryOnlyHealthComponent:JSX.Element[] = [];
        if(this.props.isPrimary || this.props.isPrimary===undefined){
            if(this.props.healthData.has(messages.Rad.HealthComponent.ENVIRONMENTAL)){
                primaryOnlyHealthComponent.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.ENVIRONMENTAL} title={"Environmental"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.ENVIRONMENTAL)}/>);
            }
            if(this.props.healthData.has(messages.Rad.HealthComponent.CAM)){
                primaryOnlyHealthComponent.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.CAM} title={"Context"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.CAM)}/>);
            }
            if(this.props.healthData.has(messages.Rad.HealthComponent.ATTRIBUTION)){
                primaryOnlyHealthComponent.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.ATTRIBUTION} title={"Attribution"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.ATTRIBUTION)}/>);
            }
        }

        let healthComponents:JSX.Element[] = [];
        if(this.props.healthData.has(messages.Rad.HealthComponent.TMU)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.TMU} title={"PERM TMU"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.TMU)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.LOG)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.LOG} title={"Data Log"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.LOG)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.GPS)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.GPS} title={"GPS"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.GPS)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.INVESTIGATION)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.INVESTIGATION} title={"Investigation Process"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.INVESTIGATION)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.RAD)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.RAD} title={"Radiation Data"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.RAD)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.PCS)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.PCS} title={"PCS Process"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.PCS)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.NEUTRON)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.NEUTRON} title={"Neutron Detector"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.NEUTRON)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.CONFIG)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.CONFIG} title={"Config Server"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.CONFIG)}/>);
        }
        if(this.props.healthData.has(messages.Rad.HealthComponent.SIGMA_EDGE)){
            healthComponents.push(<HealthComponentDisplay key={messages.Rad.HealthComponent.SIGMA_EDGE} title={"SIGMA Reporting"} healthData={this.props.healthData.get(messages.Rad.HealthComponent.SIGMA_EDGE)}/>);
        }

        const statusContainer =
            <div id="system-status-container" className={sidenavClassName} style={{cursor: 'pointer'}}>
                <div className="sidenav-menu" style={{display:'flex', flexDirection: 'row', alignItems:'center', justifyContent:'space-between'}}>
                    <div className="system-status status-metric-container">
                        <label className="status-metric-title-big">System Status</label>
                    </div>
                    <div className="closebtn" style={{cursor:'pointer'}} onClick={this.handleHealthCloseButtonClick}>&times;</div>
                </div>
                <div className="sidenav-container">
                    {healthComponents}
                    {primaryOnlyHealthComponent}
                </div>
            </div>

        return(
            <>
            {statusContainer}
            </>
        )
    }
}
